<template>
    <div class="query-term clearfix">
        <h5 class="col-xs-7">{{field.label || fieldName}}</h5><slot></slot>
        <div class="form-group col-xs-4">
            <select v-model="typeSelect" class="form-control" :disabled="disableType">
                <option v-for="availableType in field.availableTypes" v-bind:value="availableType.name" :key="availableType.name">{{availableType.label || availableType.name}}</option>
            </select>
        </div>
        <component v-bind:is="getFieldType()" :params.sync="paramSet" :field="field"></component>
    </div>
</template>

<script>
    import SearchAllWords from '@/components/search/subforms/SearchAllWords'
    import SearchAnyWords from '@/components/search/subforms/SearchAnyWords'
    import SearchPhrase from '@/components/search/subforms/SearchPhrase'
    import SearchNumber from '@/components/search/subforms/SearchNumber'
    import SearchCompareNumber from '@/components/search/subforms/SearchCompareNumber'
    import SearchCompareDate from '@/components/search/subforms/SearchCompareDate'
    import SearchDateRange from '@/components/search/subforms/SearchDateRange'
    import SearchDateRangeRelative from '@/components/search/subforms/SearchDateRangeRelative'
    import SearchSelect from '@/components/search/subforms/SearchSelect'

    export default {
        props: ['field', 'type', 'params', 'fieldName'],
        name: 'QueryTerm',
        components: {
            SearchAnyWords,
            SearchAllWords,
            SearchPhrase,
            SearchNumber,
            SearchCompareNumber,
            SearchCompareDate,
            SearchDateRange,
            SearchDateRangeRelative,
            SearchSelect
        },
        data () {
            return {
                valueCache: {}
            }
        },
        computed: {
            typeSelect: {
                get () {
                    return this.type
                },
                set (newValue) {
                    this.$emit('update:params', (this.valueCache[newValue] !== undefined ? this.valueCache[newValue] : null))
                    this.$emit('update:type', newValue)
                }
            },
            paramSet: {
                get () {
                    return this.params
                },
                set (newValue) {
                    this.valueCache[this.type] = newValue
                    this.$emit('update:params', newValue)
                }
            },
            disableType () {
                return !(this.field.availableTypes.length > 1)
            }
        },
        methods: {
            getFieldType () {
                return 'search-' + this.type.split(/(?=[A-Z])/).join('-').toLowerCase()
            }
        },
        created () {
            this.valueCache[this.type] = this.params
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// QueryTerm.vue?b6fd01c8